import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import FilterSelection from "../../visComponents/navigation/newFilters/filterSelection";
import {getBvGroupFilterValues} from "../../../api/server-api";
import {setAvailableFilterValues} from "../../../actions/filtersFunctions";
import WizardDesktopGrid from "./wizardDesktopGrid";
import {getAllFilterGroupValuesFromGroup} from "../../../misc/helpers";
import LoadingSpinner from "../../ui/loadingSpinner";
import {setSelectionWindowView} from "../../../actions/actionFunctions";
import {wizardObjectInterface} from "../../../interfaces/wizardObjectInterface";
import WizardMobileGrid from "./wizardMobileGrid";

const WizardList = (props) => {

  const {currentParent, listItemHeight, wizardConfig, activeSubStep, filterGroups, fabricatorData,
    availableFilterValues, setAvailableFilterValues, selectionWindowView, setSelectionWindowView, isMobile} = props;
  const [isLoading, setIsLoading] = useState(false);
  const [filterGroupValues, setFilterGroupValues] = useState([]);

  useEffect(() => {
    getFilterValues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSubStep]);

  const existingWizSetup = wizardConfig.find(wizObject => {
    return wizObject.featureGroupName === currentParent.dbName || wizObject.featureGroupName === currentParent.partName
  })

  const filterGroup = existingWizSetup.filterGroups[activeSubStep];

  if (!filterGroup) {
    return null
  }

  if (selectionWindowView === 4) {
    setSelectionWindowView(3);
  }

  const filterGroupAll = filterGroups.find(group => group.name === filterGroup.name);

  const filterValueIsActive = (currentActiveFilters, currentFilterValue) => {
    return currentActiveFilters[filterGroup.id] && currentActiveFilters[filterGroup.id].includes(currentFilterValue.id);
  }

  const currentActiveFilters = currentParent.activeFeature
    ? currentParent.activeFeature.dbFeature.filterValueIDs
    : {};

  const reorderFilterItems = (filteredFilterValues) => {
    // console.log("currentActiveFilters", currentActiveFilters);
    return filteredFilterValues.sort((a,b) => {
      const activeA = filterValueIsActive(currentActiveFilters, a);
      const activeB = filterValueIsActive(currentActiveFilters, b);
      return activeA !== activeB ? activeA < activeB ? -1 : 1 : 0;
    })
  };

  const getFilterValues = () => {
    const selectedFilters = []; // ??
    const filteredFilterValues = FilterSelection.getAvailableFilterValues(
      filterGroups, filterGroup.name, currentParent, fabricatorData, selectedFilters
    );
    const reorderedFilterValues = reorderFilterItems(filteredFilterValues);
    if (filterGroup.name === "Stone Color" || filterGroup.name === "Stone Material") {
      if (availableFilterValues[filterGroup.id]) {
        setFilterGroupValues(availableFilterValues[filterGroup.id]);
      } else {
        setIsLoading(true);
        getBvGroupFilterValues(currentParent.dbName || currentParent.partName, filterGroup.id)
          .then((response) => {
            setAvailableFilterValues({
              [filterGroup.id]: response.data
            });
            setIsLoading(false);
            setFilterGroupValues(response.data);
          })
      }
    } else {
      setFilterGroupValues(reorderedFilterValues);
    }
  }

  const allValues = getAllFilterGroupValuesFromGroup(filterGroupAll);

  const getRenderFilterValues = (filterGroupValuesArray) => { // here we pass array of numbers & return objects
    return allValues.filter(filObject => filterGroupValuesArray.includes(filObject.id));
  }

  if (isLoading) {
    return <LoadingSpinner/>
  }

  return isMobile
    ? <WizardMobileGrid filterGroupValues={getRenderFilterValues(filterGroupValues)}
                        listItemHeight={listItemHeight}
                        filterGroup={filterGroupAll}
                        currentActiveFilters={currentActiveFilters}
                        currentParent={currentParent}/>
    : <WizardDesktopGrid filterGroupValues={getRenderFilterValues(filterGroupValues)}
                         listItemHeight={listItemHeight}
                         filterGroup={filterGroupAll}
                         currentActiveFilters={currentActiveFilters}
                         currentParent={currentParent}/>

}

WizardList.propTypes = {
  currentParent: PropTypes.object.isRequired,
  listItemHeight: PropTypes.number,
  wizardConfig: PropTypes.arrayOf(PropTypes.shape(wizardObjectInterface)),
}

const mapStateToProps = (store) => {
  const {wizardConfig} = store.wizardState;
  const {activeSubStep, selectionWindowView} = store.selectionState;
  const {filterGroups, availableFilterValues} = store.filterState;
  const {isMobile} = store.serverState;
  return {
    wizardConfig,
    activeSubStep,
    filterGroups,
    availableFilterValues,
    fabricatorData: store.fabricatorState,
    selectionWindowView,
    isMobile
  };
};

const mapDispatchToProps = {
  setAvailableFilterValues,
  setSelectionWindowView
};

export default connect(mapStateToProps, mapDispatchToProps)(WizardList)
